import React, { useState, useEffect, Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import AccountBalance from "@material-ui/icons/AccountBalance";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { green } from "@material-ui/core/colors";
import IconButton from "@material-ui/core/IconButton";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import CouponForm from "./CouponForm";
import { Tooltip } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import "./Product.css";

const theme = createMuiTheme({
  palette: {
    primary: green,
  },
});

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(0),
  },
  input: {
    display: "none",
  },
}));

export default function ModalPaymentMethod(props) {
  const classes = useStyles();
  const {
    open,
    handleClose,
    obtenerInformacionPago,
    totalDescuento,
    informacionMetodoPago,
    generarVenta,
    handleChangeImage,
    handleChangeImageTransfer,
    image,
    imageTransfer,
    guardarTotalDescuento,
    subtotal,
    saveCouponInfo,
    couponInfo,
    branch,
    disableButton,
    saveComission,
    comission,
  } = props;

  const [mensaje, guardarMensaje] = useState("");
  const [error, guardarError] = useState(false);

  const [totalSubDiscount, saveTotalSubDiscount] = useState(0);
  const [couponDiscount, saveCouponDiscount] = useState("");
  const [disableCouponButton, saveDisableCouponButton] = useState(false);
  const [validationComission, saveValidationComission] = useState(false);

  useEffect(() => {
    saveCouponDiscount("");
    saveTotalSubDiscount(totalDescuento);
    saveCouponInfo("");
  }, [subtotal]);

  useEffect(() => {
    if (couponDiscount != "" && couponInfo != "") {
      let descuentoPorcentajeNew = couponDiscount;
      saveTotalSubDiscount(totalDescuento);
      const descuento = (descuentoPorcentajeNew * totalDescuento) / 100;
      let finaltotal = totalDescuento + descuento;
      const TotalDescuento = totalDescuento - descuento;
      guardarTotalDescuento(Math.round(TotalDescuento));
    }
  }, [couponDiscount, couponInfo]);

  useEffect(() => {
    AlertaCantidad();
    if (Number(informacionMetodoPago.card_income) > 0 && !validationComission) {
      var comision = totalDescuento * 0.01;
      saveComission(0);
      guardarTotalDescuento(Number(totalDescuento));
      saveValidationComission(true);
    }
    if (Number(informacionMetodoPago.card_income) <= 0 && validationComission) {
      saveValidationComission(false);
      guardarTotalDescuento(Number(totalDescuento) - comission);
      saveComission(0);
    }
  }, [informacionMetodoPago]);

  informacionMetodoPago.amount =
    Number(informacionMetodoPago.cash_income) +
    Number(informacionMetodoPago.card_income) +
    Number(informacionMetodoPago.transfer_income);
  var totalRestante =
    Number(totalDescuento) - Number(informacionMetodoPago.amount);

  const AlertaCantidad = () => {
    if (informacionMetodoPago.cash_income > totalDescuento) {
      if (
        Number(informacionMetodoPago.card_income) > 0 ||
        Number(informacionMetodoPago.transfer_income) > 0
      ) {
        guardarError(true);
        guardarMensaje("El monto no puede ser mayor al total a pagar");
      } else {
        guardarError(false);
      }
    } else {
      if (totalDescuento < informacionMetodoPago.amount) {
        guardarError(true);
        guardarMensaje("El monto no puede ser mayor al total a pagar");
      } else if (informacionMetodoPago.amount < 0) {
        guardarError(true);
        guardarMensaje("El monto no puede contener valores negativos");
      } else {
        guardarError(false);
      }
    }
  };

  if (informacionMetodoPago.cash_income > totalDescuento) {
    informacionMetodoPago.change =
      informacionMetodoPago.cash_income - totalDescuento;
  }

  const fmtCurrency = (val) =>
    new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN",
      minimumFractionDigits: 2,
    }).format(isNaN(val) ? 0 : val);

  const total_amount = fmtCurrency(informacionMetodoPago.amount);
  const total_remaining = fmtCurrency(totalRestante);

  return (
    <Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: { borderRadius: 16, overflow: "auto" },
        }}
      >
        {/* ── Modal Header with Total ── */}
        <div className="payment-modal-title">
          <h2>Realizar Pago</h2>
          <div className="modal-total">{fmtCurrency(totalDescuento)}</div>
        </div>

        {/* ── Summary Bar ── */}
        <div className="payment-summary-bar">
          <div className="stat">
            <div className="stat-label">Pagado</div>
            <div className="stat-value">{total_amount}</div>
          </div>
          <div className="stat">
            <div className="stat-label">Restante</div>
            <div className="stat-value">{total_remaining}</div>
          </div>
          {informacionMetodoPago.cash_income > totalDescuento && (
            <div className="stat">
              <div className="stat-label">Cambio</div>
              <div className="stat-value change">
                {fmtCurrency(informacionMetodoPago.change)}
              </div>
            </div>
          )}
        </div>

        {/* ── Payment Methods ── */}
        <form onSubmit={generarVenta}>
          <DialogContent style={{ padding: 0 }}>
            {/* ── Coupon Section ── */}
            <div className="coupon-section">
              <CouponForm
                saveCouponDiscount={saveCouponDiscount}
                saveCouponInfo={saveCouponInfo}
                saveDisableCouponButton={saveDisableCouponButton}
                disableCouponButton={disableCouponButton}
                branch={branch}
                couponDiscount={couponDiscount}
              />
              {couponInfo != "" && (
                <div style={{ marginTop: 8 }}>
                  <span style={{ fontSize: "0.82rem", color: "#666" }}>
                    Subtotal: {fmtCurrency(totalSubDiscount)} →
                    Descuento: <b style={{ color: "#e53935" }}>{couponInfo.discount}%</b>
                  </span>
                </div>
              )}
            </div>

            <div className="payment-methods-grid">
              <Grid container spacing={2}>
              {/* Cash */}
              <Grid item xs={12} md={4}>
                <div
                  className={`payment-method-card ${Number(informacionMetodoPago.cash_income) > 0 ? "active" : ""
                    }`}
                >
                  <LocalAtmIcon className="method-icon" />
                  <label>Efectivo</label>
                  <TextField
                    id="cash_income"
                    placeholder="$0.00"
                    fullWidth
                    type="number"
                    name="cash_income"
                    variant="outlined"
                    size="small"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <MonetizationOn style={{ fontSize: 18, color: "#aaa" }} />
                        </InputAdornment>
                      ),
                    }}
                    onChange={(e) => obtenerInformacionPago(e)}
                  />
                  {error && (
                    <p style={{ color: "red", fontSize: "0.72rem", margin: "4px 0 0" }}>
                      {mensaje}
                    </p>
                  )}
                </div>
              </Grid>

              {/* Card */}
              <Grid item xs={12} md={4}>
                <div
                  className={`payment-method-card ${Number(informacionMetodoPago.card_income) > 0 ? "active" : ""
                    }`}
                >
                  <CreditCardIcon className="method-icon" />
                  <label>Tarjeta</label>
                  <TextField
                    id="card_income"
                    placeholder="$0.00"
                    fullWidth
                    name="card_income"
                    variant="outlined"
                    size="small"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <MonetizationOn style={{ fontSize: 18, color: "#aaa" }} />
                        </InputAdornment>
                      ),
                    }}
                    onChange={(e) => obtenerInformacionPago(e)}
                  />
                  {error && (
                    <p style={{ color: "red", fontSize: "0.72rem", margin: "4px 0 0" }}>
                      {mensaje}
                    </p>
                  )}
                  {informacionMetodoPago.card_income > 0 && (
                    <div className="upload-area" style={{ marginTop: 10 }}>
                      <input
                        className={classes.input}
                        id="icon-button-file"
                        type="file"
                        name="image"
                        accept="image/png, image/jpg, image/jpeg"
                        onChange={handleChangeImage}
                      />
                      <label htmlFor="icon-button-file" style={{ cursor: "pointer" }}>
                        {image.image ? (
                          <img src={image.urlPhoto} alt="Ticket" />
                        ) : (
                          <>
                            <PhotoCamera style={{ fontSize: 28, color: "#aaa" }} />
                            <p style={{ fontSize: "0.72rem", color: "#999", margin: "4px 0 0" }}>
                              Foto del ticket
                            </p>
                          </>
                        )}
                      </label>
                    </div>
                  )}
                </div>
              </Grid>

              {/* Transfer */}
              <Grid item xs={12} md={4}>
                <div
                  className={`payment-method-card ${Number(informacionMetodoPago.transfer_income) > 0 ? "active" : ""
                    }`}
                >
                  <SwapHorizIcon className="method-icon" />
                  <label>Transferencia</label>
                  <TextField
                    id="transfer_income"
                    placeholder="$0.00"
                    fullWidth
                    type="number"
                    name="transfer_income"
                    variant="outlined"
                    size="small"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <MonetizationOn style={{ fontSize: 18, color: "#aaa" }} />
                        </InputAdornment>
                      ),
                    }}
                    onChange={(e) => obtenerInformacionPago(e)}
                  />
                  {error && (
                    <p style={{ color: "red", fontSize: "0.72rem", margin: "4px 0 0" }}>
                      {mensaje}
                    </p>
                  )}
                  {informacionMetodoPago.transfer_income > 0 && (
                    <>
                      <TextField
                        id="reference"
                        placeholder="Referencia"
                        fullWidth
                        required
                        type="number"
                        variant="outlined"
                        size="small"
                        style={{ marginTop: 10 }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <AccountBalance style={{ fontSize: 18, color: "#aaa" }} />
                            </InputAdornment>
                          ),
                        }}
                        name="reference"
                        onChange={(e) => obtenerInformacionPago(e)}
                      />
                      <div className="upload-area" style={{ marginTop: 10 }}>
                        <input
                          className={classes.input}
                          id="icon-button-file-transfer"
                          type="file"
                          name="image"
                          accept="image/png, image/jpg, image/jpeg"
                          onChange={handleChangeImageTransfer}
                        />
                        <label htmlFor="icon-button-file-transfer" style={{ cursor: "pointer" }}>
                          {imageTransfer.image ? (
                            <img src={imageTransfer.urlPhoto} alt="Ticket transferencia" />
                          ) : (
                            <>
                              <PhotoCamera style={{ fontSize: 28, color: "#aaa" }} />
                              <p style={{ fontSize: "0.72rem", color: "#999", margin: "4px 0 0" }}>
                                Foto del comprobante
                              </p>
                            </>
                          )}
                        </label>
                      </div>
                    </>
                  )}
                </div>
              </Grid>
              </Grid>
            </div>
          </DialogContent>

          {/* ── Actions ── */}
          <DialogActions className="modal-actions">
            <Button
              onClick={() => handleClose()}
              color="secondary"
              variant="outlined"
              className="modal-cancel-btn"
            >
              Cancelar
            </Button>
            {!disableButton ? (
              <Button
                type="submit"
                autoFocus
                variant="contained"
                className="modal-save-btn"
              >
                Confirmar Venta
              </Button>
            ) : (
              <Button
                type="submit"
                disabled
                variant="contained"
                className="modal-save-btn"
              >
                Procesando...
              </Button>
            )}
          </DialogActions>
        </form>
      </Dialog>
    </Fragment>
  );
}
